import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {t} from '../../../../../../services/i18n';
import {formatPriceWithCurrencyLTR} from '../../../../../../services/Helpers';
import {GlobalStyleAttributes} from '../../../../../../styles/GlobalStyles';
import HStack from '../../../../../common/Layout/HStack';
import AppText from '../../../../../common/AppText';
import {HOK, IMMEDIATE} from '../../../../../../services/ConstHelper';
import {SESSION_PER_WEEK_LABELS} from '../../../../../../../web/src/components/Track/TrackConsts';

const COL_WIDTHS = {
    name: '345px',
    price: '150px',
    frequency: '300px',
};

const wrapColumnStyle = (width) => ({
    width,
    flexShrink: 0,
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    alignSelf: 'center',
});

const TrackCollapseLabel = ({track}) => {
    const box = useSelector((state) => state.box.box);
    const currencySymbol = useMemo(() => box?.locations_box?.[0]?.currency_symbol ?? '₪', [box]);

    const formatBasePrice = () => {
        const recurringMt = track.membership_types_all?.find(mt => mt.type === 'recurring');
        const regularMt = track.membership_types_all?.find(mt => mt.type === 'regular');
        const parts = [];
        if (recurringMt) {
            parts.push(t('price-track-recurring-payment', { price: formatPriceWithCurrencyLTR(recurringMt.price, currencySymbol) }));
        }
        if (regularMt) {
            parts.push(t('price-track-regular-payment', { price: formatPriceWithCurrencyLTR(regularMt.price, currencySymbol) }));
        }
        return parts.length ? parts.join(' ') : null;
    };

    return (
        <HStack alignItems={'flex-start'} flex={1} space={'1.5rem'} style={{minWidth: 0}}>
            <AppText
                fontSize={GlobalStyleAttributes.fonts.heading3}
                boldFont
                style={wrapColumnStyle(COL_WIDTHS.name)}
            >
                {track.name}
            </AppText>
            <AppText fontSize={GlobalStyleAttributes.fonts.heading3} style={wrapColumnStyle(COL_WIDTHS.price)}>
                {formatBasePrice() ?? '—'}
            </AppText>
            <AppText fontSize={GlobalStyleAttributes.fonts.heading3} style={wrapColumnStyle(COL_WIDTHS.frequency)}>
                {t(`frequency-track-label`, {frequency: track.session_per_week}) ?? '—'}
            </AppText>
        </HStack>
    );
};

export default TrackCollapseLabel;
